<template>
	<div class="vp-page">
		<!-- ===== 1. 会员权益功能对比表（个人版 + 企业版融合） ===== -->
		<div class="vp-band vp-band--compare">
			<div class="vp-section">
				<div class="vp-section-header">
					<h2 class="vp-section-title">会员权益功能对比</h2>
					<p class="vp-section-subtitle">全面了解各版本功能差异，选择最适合您的方案</p>
				</div>

				<div class="vp-compare-wrap">
					<table class="vp-compare-table">
						<colgroup>
							<col class="col-category" />
							<col class="col-feature" />
							<col class="col-tourist" />
							<col class="col-normal" />
							<col class="col-vip" />
							<col class="col-basic" />
							<col class="col-pro" />
							<col class="col-max" />
						</colgroup>
						<thead>
							<tr class="tr-group-header">
								<th class="th-diagonal" colspan="2" rowspan="2" style="border-right: 2px solid #eaeaea">
									<span class="diagonal-label-top">分类</span>
									<span class="diagonal-label-bottom">级别</span>
								</th>
								<th class="th-tourist" rowspan="2">游客</th>
								<th class="th-group-personal" colspan="2">个人版</th>
								<th class="th-group-company" colspan="3">企业版</th>
							</tr>
							<tr class="tr-group-header">
								<th class="th-normal">普通用户</th>
								<th class="th-vip">VIP用户</th>
								<th class="th-basic">基础版</th>
								<th class="th-pro">专业版</th>
								<th class="th-max">旗舰版</th>
							</tr>
						</thead>
						<tbody>
							<!-- ===== 账号权益 ===== -->
							<tr>
								<td class="td-category" rowspan="4"><b>账号权益</b></td>
							</tr>
							<tr>
								<td style="border-right: 2px solid #eaeaea">是否付费</td>
								<td>/</td>
								<td>否</td>
								<td>是</td>
								<td>否</td>
								<td>是</td>
								<td>是</td>
							</tr>
							<tr>
								<td style="border-right: 2px solid #eaeaea">账号数量</td>
								<td>/</td>
								<td>/</td>
								<td>/</td>
								<td>1+9</td>
								<td>1+9</td>
								<td>1+9</td>
							</tr>
							<tr style="border-bottom: 2px solid #eaeaea">
								<td style="border-right: 2px solid #eaeaea">注册赠送</td>
								<td>/</td>
								<td class="th-pro">送7天VIP</td>
								<td>/</td>
								<td>/</td>
								<td>/</td>
								<td>/</td>
							</tr>
							<!-- ===== 法规标准库 ===== -->
							<tr>
								<td class="td-category" rowspan="6"><b>法规标准库</b></td>
							</tr>
							<tr>
								<td style="border-right: 2px solid #eaeaea">特种设备列表</td>
								<td>/</td>
								<td class="checkmark">✓</td>
								<td class="checkmark">✓</td>
								<td class="checkmark">✓</td>
								<td class="checkmark">✓</td>
								<td class="checkmark">✓</td>
							</tr>
							<tr>
								<td style="border-right: 2px solid #eaeaea">全国标准库列表</td>
								<td class="crossmark">✕</td>
								<td class="checkmark">✓</td>
								<td class="checkmark">✓</td>
								<td class="checkmark">✓</td>
								<td class="checkmark">✓</td>
								<td class="checkmark">✓</td>
							</tr>
							<tr>
								<td style="border-right: 2px solid #eaeaea">公开文件阅读</td>
								<td class="crossmark">✕</td>
								<td class="checkmark">✓</td>
								<td class="checkmark">✓</td>
								<td class="checkmark">✓</td>
								<td class="checkmark">✓</td>
								<td class="checkmark">✓</td>
							</tr>
							<tr>
								<td style="border-right: 2px solid #eaeaea">VIP文件阅读</td>
								<td class="crossmark">✕</td>
								<td class="crossmark">✕</td>
								<td class="checkmark">✓</td>
								<td class="crossmark">✕</td>
								<td class="checkmark">✓</td>
								<td class="checkmark">✓</td>
							</tr>
							<tr style="border-bottom: 2px solid #eaeaea">
								<td style="border-right: 2px solid #eaeaea">官方链接</td>
								<td class="crossmark">✕</td>
								<td class="checkmark">✓</td>
								<td class="checkmark">✓</td>
								<td class="checkmark">✓</td>
								<td class="checkmark">✓</td>
								<td class="checkmark">✓</td>
							</tr>

							<!-- ===== AI问答 ===== -->
							<tr>
								<td class="td-category" rowspan="6"><b>AI问答</b></td>
							</tr>
							<tr>
								<td style="border-right: 2px solid #eaeaea">自动模式</td>
								<td>每天3次</td>
								<td>每月20次</td>
								<td class="checkmark">✓</td>
								<td>每月20次</td>
								<td class="checkmark">✓</td>
								<td class="checkmark">✓</td>
							</tr>
							<tr>
								<td style="border-right: 2px solid #eaeaea">快速回答</td>
								<td class="crossmark">✕</td>
								<td class="checkmark">✓</td>
								<td class="checkmark">✓</td>
								<td class="checkmark">✓</td>
								<td class="checkmark">✓</td>
								<td class="checkmark">✓</td>
							</tr>
							<tr>
								<td style="border-right: 2px solid #eaeaea">深入思考</td>
								<td class="crossmark">✕</td>
								<td class="crossmark">✕</td>
								<td class="checkmark">✓</td>
								<td class="crossmark">✕</td>
								<td class="checkmark">✓</td>
								<td class="checkmark">✓</td>
							</tr>
							<tr>
								<td style="border-right: 2px solid #eaeaea">书单模式</td>
								<td class="crossmark">✕</td>
								<td class="checkmark">✓</td>
								<td class="checkmark">✓</td>
								<td class="checkmark">✓</td>
								<td class="checkmark">✓</td>
								<td class="checkmark">✓</td>
							</tr>
							<tr style="border-bottom: 2px solid #eaeaea">
								<td style="border-right: 2px solid #eaeaea">会话历史</td>
								<td class="crossmark">✕</td>
								<td>30天</td>
								<td class="th-pro">永久</td>
								<td>30天</td>
								<td class="th-pro">永久</td>
								<td class="th-pro">永久</td>
							</tr>

							<!-- ===== 智能工具 ===== -->
							<!-- <tr>
								<td class="td-category" rowspan="3"><b>智能工具</b></td>
							</tr>
							<tr>
								<td style="border-right: 2px solid #eaeaea">鉴定评审智能辅助系统（企业版）</td>
								<td>/</td>
								<td>/</td>
								<td>/</td>
								<td class="crossmark">✕</td>
								<td class="crossmark">✕</td>
								<td class="checkmark">✓</td>
							</tr>
							<tr style="border-bottom: 2px solid #eaeaea">
								<td style="border-right: 2px solid #eaeaea">文件合规审查系统</td>
								<td>/</td>
								<td class="crossmark">✕</td>
								<td class="checkmark">✓</td>
								<td class="crossmark">✕</td>
								<td class="crossmark">✕</td>
								<td class="checkmark">✓</td>
							</tr> -->

							<!-- ===== 个人书架 ===== -->
							<tr>
								<td class="td-category" rowspan="3"><b>个人书架</b></td>
							</tr>
							<tr>
								<td style="border-right: 2px solid #eaeaea">已购标准</td>
								<td>/</td>
								<td class="checkmark">✓</td>
								<td class="checkmark">✓</td>
								<td>/</td>
								<td>/</td>
								<td>/</td>
							</tr>

							<tr style="border-bottom: 2px solid #eaeaea">
								<td style="border-right: 2px solid #eaeaea">法规标准收藏</td>
								<td>/</td>
								<td class="checkmark">✓</td>
								<td class="checkmark">✓</td>
								<td>/</td>
								<td>/</td>
								<td>/</td>
							</tr>

							<!-- ===== 企业资料馆 ===== -->
							<tr>
								<td class="td-category" rowspan="6"><b>企业资料馆</b></td>
							</tr>
							<tr>
								<td style="border-right: 2px solid #eaeaea">已购标准</td>
								<td>/</td>
								<td>/</td>
								<td>/</td>
								<td class="checkmark">✓</td>
								<td class="checkmark">✓</td>
								<td class="checkmark">✓</td>
							</tr>
							<tr>
								<td style="border-right: 2px solid #eaeaea">标准查新</td>
								<td>/</td>
								<td>/</td>
								<td>/</td>
								<td class="crossmark">✕</td>
								<td class="crossmark">✕</td>
								<td class="checkmark">✓</td>
							</tr>
							<tr>
								<td style="border-right: 2px solid #eaeaea">法规标准收藏</td>
								<td>/</td>
								<td>/</td>
								<td>/</td>
								<td>可使用，不可导出正版说明</td>
								<td class="checkmark">✓</td>
								<td class="checkmark">✓</td>
							</tr>
							<tr>
								<td style="border-right: 2px solid #eaeaea">企业资料</td>
								<td>/</td>
								<td>/</td>
								<td>/</td>
								<td class="crossmark">✕</td>
								<td>10G</td>
								<td>50G</td>
							</tr>
							<tr style="border-bottom: 2px solid #eaeaea">
								<td style="border-right: 2px solid #eaeaea">个人资料</td>
								<td>/</td>
								<td>/</td>
								<td>/</td>
								<td class="crossmark">✕</td>
								<td>1G/人</td>
								<td>5G/人</td>
							</tr>

							<!-- ===== 正版图书购买 ===== -->
							<tr>
								<td class="td-category" rowspan="3"><b>正版图书购买</b></td>
							</tr>
							<tr>
								<td style="border-right: 2px solid #eaeaea">纸质版</td>
								<td>/</td>
								<td>88折</td>
								<td>85折</td>
								<td>85折</td>
								<td>85折</td>
								<td>85折</td>
							</tr>
							<tr>
								<td style="border-right: 2px solid #eaeaea">电子版</td>
								<td>/</td>
								<td>85折</td>
								<td>80折</td>
								<td>80折</td>
								<td>80折</td>
								<td>80折</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
		<!-- /vp-band--compare -->

		<!-- ===== 2. VIP会员套餐（个人版） ===== -->
		<div class="vp-band vp-band--vip" style="background: #f0f4fb">
			<div class="vp-section">
				<div class="vp-section-header">
					<h2 class="vp-section-title">VIP 会员套餐</h2>
					<p class="vp-section-subtitle">个人版 · 选择适合您的会员等级</p>
				</div>

				<!-- 用户信息 -->
				<!-- <div class="vp-user-info" v-if="uisLogin">
					<div class="vp-user-card">
						<div class="vp-user-avatar">
							<el-avatar :size="48" style="cursor: pointer; background: #fff">
								<img :src="avatarUrl" height="48" width="48" />
							</el-avatar>
							<i v-if="vipStatus.showIcon" class="iconfont icon-VIP" :style="{ color: vipIconColor, fontSize: '26px', position: 'absolute', top: '-14px', left: '32px' }"></i>
						</div>
						<div class="vp-user-body">
							<span class="vp-user-name">{{ uinfo.nickName }}，您好！</span>
							<span class="vp-user-level">{{ getDisplayLevelName() }}</span>
						</div>
					</div>
				</div> -->

				<!-- VIP价格卡片 -->
				<div class="vp-price-row">
					<div v-for="(item, index) in vipInfo" :key="index" :class="['vpc', getCardClass(index), { 'vpc-selected': selectedCard === index }]" @click="selectCard(index)">
						<el-tag v-if="calculateDiscount(item) !== null" size="mini" type="danger" class="vpc-discount-tag">{{ (calculateDiscount(item) * 10).toFixed(1) }}折</el-tag>
						<div class="vpc-icon"><i :class="getCardIcon(index)"></i></div>
						<div class="vpc-name">{{ item.skuName }}</div>
						<div class="vpc-price">
							<div class="vpc-price-now">
								<span class="vpc-unit">¥</span>
								<span class="vpc-num">{{ getDisplayPrice(item) }}</span>
							</div>
							<div class="vpc-price-original" v-if="item.fixedPrice && Number(getDisplayPrice(item)) !== Number(item.fixedPrice)">
								<span>原价 ¥{{ item.fixedPrice }}</span>
							</div>
						</div>
						<el-button :type="selectedCard === index ? 'primary' : 'default'" class="vpc-buy-btn" @click.stop="uisLogin ? handleBuy(0) : setLoginShowPersonal(true)"> 立即开通 </el-button>
						<div class="selected-triangle" v-if="selectedCard === index">
							<i class="el-icon-check"></i>
						</div>
					</div>
				</div>

				<!-- 购买区域 -->
				<div class="vp-buy-wrap" v-if="uisLogin">
					<div class="vp-buy-card">
						<div class="vp-buy-info">
							<p class="vp-buy-text">
								您即将开通 <b>{{ vipInfo[selectedCard].skuName }}</b
								>，应付金额 <b class="vp-buy-price">¥{{ getDisplayPrice(vipInfo[selectedCard]) }}</b>
							</p>
							<ul class="vp-pay-methods">
								<li @click="handleBuy(0)" v-click-once="3000">
									<img src="@/assets/images/weixin.png" alt="" />
									<span>微信支付</span>
								</li>
								<li @click="handleBuy(1)" v-click-once="3000">
									<img src="@/assets/images/zhifubao.png" alt="" />
									<span>支付宝支付</span>
								</li>
							</ul>
							<p class="vp-buy-desc">温馨提示：企业用户批量购买VIP账号可享专属优惠，欢迎联系我们了解更多详情，联系电话：18911620150。</p>
						</div>
						<div class="vp-invite-code">
							<i class="iconfont icon-yaoqingma"></i>
							<span @click="toInviteCode">邀请码兑换</span>
						</div>
					</div>
				</div>
			</div>

			<!-- ===== 促销横幅（未登录） ===== -->
			<div class="vp-section">
				<div class="vp-contact-us" v-if="!uisLogin">
					<div class="vp-contact-card">
						<div class="vp-contact-icon">
							<i class="iconfont icon-vip1"></i>
						</div>
						<div class="vp-contact-body">
							<span class="vp-contact-label"><b>免费</b>注册，限时<b>优惠中</b>，注册即送<b>7天</b>VIP。</span>
							<span class="vp-contact-sub">（VIP按需购买，无自动续费。）</span>
						</div>
						<el-button type="primary" round @click="toRegister" class="vp-register-btn">注册账号</el-button>
					</div>
				</div>
			</div>
		</div>
		<!-- /vp-band--vip -->

		<!-- ===== 3. 企业版本套餐 ===== -->
		<div class="vp-band vp-band--enterprise">
			<div class="vp-section">
				<div class="vp-section-header">
					<h2 class="vp-section-title">企业版本套餐</h2>
					<p class="vp-section-subtitle">专为企业打造的标准知识管理平台，选择最适合您团队的方案</p>
				</div>

				<div class="vp-price-row vp-enterprise-row">
					<div class="vpc vpc-basic">
						<div class="vpc-icon"><i class="el-icon-star-off"></i></div>
						<div class="vpc-name">基础版</div>
						<ul class="vpc-features">
							<li>1 管理员 + 9 子账号</li>
							<li>法规标准库查阅</li>
							<li>AI快速问答</li>
						</ul>
					</div>
					<div class="vpc vpc-pro">
						<div class="vpc-icon"><i class="el-icon-trophy"></i></div>
						<div class="vpc-name">专业版</div>
						<ul class="vpc-features">
							<li>1 管理员 + 9 子账号</li>
							<li>VIP文件阅读</li>
							<li>AI深入思考</li>
							<li>企业知识库管理</li>
							<li>个人知识库管理</li>
						</ul>
					</div>
					<div class="vpc vpc-max">
						<div class="vpc-icon"><i class="el-icon-medal-1"></i></div>
						<div class="vpc-name">旗舰版</div>
						<ul class="vpc-features">
							<li>1 管理员 + 9 子账号</li>
							<li>权限精细管理</li>
							<li>团队协作</li>
							<li>企业知识库管理</li>
							<li>个人知识库管理</li>
							<li>标准查新</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
		<!-- /vp-band--enterprise -->

		<!-- ===== 4. 联系方式 ===== -->
		<div class="vp-band vp-band--contact">
			<div class="vp-section vp-section--contact">
				<div class="vp-contact-bar">
					<div class="vp-contact-bar-left">
						<div class="vp-contact-icon-wrap">
							<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
								<path
									d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
								/>
							</svg>
						</div>
						<span class="vp-contact-bar-label">需要购买请和我们联系：</span>
					</div>
					<a class="vp-contact-bar-phone">18911620150</a>
				</div>
			</div>
		</div>
		<!-- /vp-band--contact -->

		<!-- 邀请码兑换弹框 -->
		<DialogInviteCode :visible.sync="showInviteCodeDialog" @success="handleInviteCodeSuccess" />
	</div>
</template>

<script>
	import { getVipInfo, postOrderVipBuy } from '@/api/vip/vip.js';
	import { mapGetters, mapActions } from 'vuex';
	import FileInfo from '@/utils/GetFileUrl.js';
	import DialogInviteCode from '@/views/VIP/components/DialogInviteCode.vue';

	export default {
		name: 'VIPGoodsList',
		components: {
			DialogInviteCode
		},
		data() {
			return {
				userPhoto: require('@/assets/images/user.png'),
				avatarUrl: '',
				vipInfo: [],
				selectedCard: null,
				showInviteCodeDialog: false
			};
		},
		computed: {
			...mapGetters('Cart', ['isVipUser']),
			...mapGetters('User', ['uinfo', 'uisLogin']),

			vipStatus() {
				if (!this.uinfo || !this.uinfo.levelId || !this.uinfo.levelEnd) {
					return { isVip: false, isExpired: false, showIcon: false };
				}
				const now = new Date();
				const levelEnd = new Date(this.uinfo.levelEnd);
				const isExpired = levelEnd < now;
				return { isVip: true, isExpired, showIcon: true };
			},
			vipIconColor() {
				if (!this.vipStatus.showIcon) return 'transparent';
				return this.vipStatus.isExpired ? '#999999' : 'rgb(255, 186, 45)';
			}
		},
		watch: {
			'uinfo.avatar': {
				async handler(newVal) {
					if (newVal) {
						const prefix = '/third/files/info/';
						const key = newVal.replace(prefix, '');
						this.avatarUrl = await FileInfo.getFileUrl(key);
					} else {
						this.avatarUrl = this.userPhoto;
					}
				},
				immediate: true,
				deep: true
			}
		},
		created() {
			this.getVipInfo();
		},
		methods: {
			...mapActions('User', ['logout']),
			...mapActions('Settings', ['setLoginShow', 'setLoginShowPersonal', 'setRegisterShow']),

			toInviteCode() {
				this.showInviteCodeDialog = true;
			},

			handleInviteCodeSuccess() {
				this.$message({
					message: '邀请码兑换成功，需要重新登录才可更新会员状态!',
					type: 'success',
					duration: 7000
				});
				setTimeout(() => {
					this.logout().then(() => {
						this.setLoginShowPersonal(true);
					});
				}, 3000);
			},

			toRegister() {
				this.setRegisterShow(true);
			},

			getDisplayLevelName() {
				if (!this.uinfo || !this.uinfo.levelId) return '';
				if (this.vipStatus.isVip) {
					return this.vipStatus.isExpired ? `VIP会员 过期时间为${this.uinfo.levelEnd}，请及时续费` : `VIP会员 有效期至 ${this.uinfo.levelEnd}`;
				}
				return '';
			},

			async getVipInfo() {
				const res = await getVipInfo();
				if (res.code === 200) {
					this.vipInfo = res.data[0].skuInfo.slice(0, 3).map(item => ({ ...item }));
					if (this.vipInfo.length > 0) {
						this.selectedCard = this.vipInfo.length - 1;
					}
				}
			},

			selectCard(index) {
				this.selectedCard = index;
			},

			getCardIcon(index) {
				const icons = ['el-icon-star-off', 'el-icon-trophy', 'el-icon-medal-1'];
				return icons[index] || 'el-icon-star-off';
			},

			getCardClass(index) {
				const classes = ['vpc-basic', 'vpc-pro', 'vpc-max'];
				return classes[index] || 'vpc-basic';
			},

			getDisplayPrice(item) {
				return this.isVipUser ? item.vipPrice : item.salePrice;
			},

			calculateDiscount(item) {
				const displayPrice = this.getDisplayPrice(item);
				const originalPrice = item.fixedPrice;
				if (!displayPrice || !originalPrice || originalPrice <= 0) return null;
				if (displayPrice >= originalPrice) return null;
				const discountRate = displayPrice / originalPrice;
				const roundedDiscount = parseFloat(discountRate.toFixed(2));
				return roundedDiscount >= 1 ? null : roundedDiscount;
			},

			handleBuy(type) {
				if (!this.uisLogin) {
					this.setLoginShowPersonal(true);
					return;
				}
				if (this.selectedCard === null) {
					this.$message.warning('请先选择要购买的VIP套餐');
					return;
				}
				const selectedItem = this.vipInfo[this.selectedCard];
				const purchaseData = {
					skuId: selectedItem.skuId,
					buyNum: 1,
					payType: type,
					invoiceHad: 0
				};
				postOrderVipBuy(purchaseData).then(res => {
					if (res.code === 200) {
						const payRoutes = ['WeChatPay', 'AlipayPay'];
						this.$router.push({
							path: `/${payRoutes[type] || 'WeChatPay'}`,
							query: {
								orderId: res.data,
								total: this.getDisplayPrice(selectedItem),
								productName: selectedItem.skuName
							}
						});
					} else {
						this.$message.error(res.msg);
					}
				});
			}
		}
	};
</script>
<style lang="less" scoped>
	/* ===== 配色体系 ===== */
	@basic: #909399;
	@pro: #2563eb;
	@max: #f97316;

	@pro-light: #5b8def;
	@pro-dark: #1d4ed8;
	@max-light: #fb923c;
	@max-dark: #ea580c;

	/* ===== 页面容器 ===== */
	.vp-page {
		min-height: 100vh;
		background: #eef1f7;
	}

	/* ===== 全宽背景带 ===== */
	.vp-band {
		width: 100%;
		padding: 56px 0 40px;

		&.vp-band--compare {
			background: #fff;
		}

		&.vp-band--enterprise {
			background: #fff;
		}

		&.vp-band--contact {
			background: #fff;
			padding: 32px 0 20px;
			margin-top: -54px;
		}
	}

	/* ===== 区块内容约束宽 ===== */
	.vp-section {
		max-width: 1200px;
		margin: 0 auto;
		padding: 0 20px;

		&.vp-section--contact {
			padding: 0 20px 20px;
		}
	}

	/* ===== 区块标题 ===== */
	.vp-section-header {
		text-align: center;
		margin-bottom: 36px;

		.vp-section-title {
			font-size: 28px;
			font-weight: 700;
			color: #1a1f2e;
			margin: 0 0 10px;
			letter-spacing: 1px;
		}

		.vp-section-subtitle {
			font-size: 14px;
			color: #8a90a2;
			margin: 0 0 12px;
		}

		&::after {
			content: '';
			display: block;
			width: 40px;
			height: 3px;
			background: @pro;
			border-radius: 2px;
			margin: 0 auto;
		}
	}

	/* ===== 功能对比表 ===== */
	.vp-compare-wrap {
		border-radius: 10px;
		overflow: hidden;
		border: 1px solid #e2e8f0;
		margin-bottom: 0;
		box-shadow: 0 2px 16px rgba(0, 0, 0, 0.06);
		background: #fff;
	}

	.vp-compare-table {
		width: 100%;
		border-collapse: collapse;
		font-family: 'PingFang SC', 'Microsoft YaHei', 'Helvetica Neue', sans-serif;

		colgroup {
			.col-category {
				width: 8%;
			}
			.col-feature {
				width: 11%;
			}
			.col-tourist {
				width: 11%;
			}
			.col-normal,
			.col-vip,
			.col-basic,
			.col-pro,
			.col-max {
				width: 13%;
			}
		}

		thead tr {
			background: #f8f9fb;
		}

		.tr-group-header th {
			padding: 12px 8px;
			font-size: 13px;
			font-weight: 700;
			text-align: center;
			border-bottom: 1px solid #e8eaed;
			border-right: 1px solid #e8eaed;
			color: #333;
			&:last-child {
				border-right: none;
			}
		}

		.th-group-personal {
			color: #2563eb;
			background: #eef3ff;
			font-size: 14px;
		}

		.th-group-company {
			color: #f97316;
			background: #fff7ed;
			font-size: 14px;
		}

		th {
			padding: 14px 8px;
			font-weight: 600;
			border-bottom: 2px solid #e8eaed;
			border-right: 1px solid #e8eaed;
			vertical-align: middle;
			text-align: center;
			font-size: 13px;
			color: #333;
			&:last-child {
				border-right: none;
			}
		}

		.th-category {
			text-align: center;
			font-size: 14px;
			color: #333;
			background: #f0f2f5;
			font-weight: 700;
			vertical-align: middle;
		}

		/* 斜线表头：分类 + 级别 */
		.th-diagonal {
			position: relative;
			padding: 0 !important;
			background: linear-gradient(to top right, transparent calc(50% - 0.5px), #d0d5dd calc(50% - 0.5px), #d0d5dd calc(50% + 0.5px), transparent calc(50% + 0.5px)), #f0f2f5;
			min-width: 120px;
			vertical-align: top !important;

			.diagonal-label-bottom {
				position: absolute;
				bottom: 55px;
				right: 42px;
				font-size: 13px;
				font-weight: 600;
				color: #666;
			}

			.diagonal-label-top {
				position: absolute;
				top: 54px;
				left: 32px;
				font-size: 13px;
				font-weight: 600;
				color: #666;
			}
		}

		.th-tourist {
			font-size: 13px;
			color: @basic;
			font-weight: 600;
			background: #fafbfd;
		}

		.th-normal {
			color: #666;
			font-weight: 600;
		}
		.th-vip {
			color: @pro;
			font-weight: 700;
			font-size: 14px;
		}
		.th-basic {
			color: #666;
			font-weight: 600;
		}
		.th-pro {
			color: @pro;
			font-weight: 700;
			font-size: 14px;
		}
		.th-max {
			color: @max;
			font-weight: 700;
			font-size: 14px;
		}

		tbody tr {
			&:nth-child(odd) {
				background: #fff;
			}
			&:nth-child(even) {
				background: #fafbfc;
			}
			&:hover {
				background: #f0f4ff;
			}
		}

		td {
			padding: 14px 8px;
			border-right: 1px solid #e8eaed;
			border-bottom: 1px solid #e8eaed;
			vertical-align: middle;
			font-size: 13px;
			text-align: center;
			color: #4a4f5e;
			&:first-child {
				text-align: left;
				padding-left: 12px;
			}
			&:last-child {
				border-right: none;
			}
		}

		.td-category {
			text-align: center !important;
			font-weight: 700;
			font-size: 13px;
			color: @pro;
			background: #f5f7fa;
			vertical-align: middle;
			padding-left: 6px !important;
		}

		.checkmark {
			color: #10b981;
			font-weight: 700;
			font-size: 15px;
		}

		.crossmark {
			color: #ef4444;
			font-weight: 600;
			font-size: 15px;
		}
	}

	/* ===== 用户信息卡片 ===== */
	.vp-user-info {
		margin-bottom: 24px;
	}

	.vp-user-card {
		display: flex;
		align-items: center;
		gap: 14px;
		padding: 18px 24px;
		border-radius: 10px;
		background: rgba(255, 255, 255, 0.8);
		border: 1px solid rgba(37, 99, 235, 0.12);
		backdrop-filter: blur(4px);
	}

	.vp-user-avatar {
		position: relative;
		flex-shrink: 0;
	}
	.vp-user-body {
		display: flex;
		flex-direction: column;
		gap: 4px;
	}
	.vp-user-name {
		font-size: 15px;
		color: #1a1f2e;
		font-weight: 600;
	}
	.vp-user-level {
		font-size: 13px;
		color: #64748b;
	}

	/* ===== 价格卡片行 ===== */
	.vp-price-row {
		display: flex;
		gap: 20px;
		margin-bottom: 24px;
	}

	.vpc {
		flex: 1;
		border-radius: 12px;
		border: 1.5px solid #e2e8f0;
		background: #fff;
		padding: 28px 20px 22px;
		display: flex;
		flex-direction: column;
		align-items: center;
		text-align: center;
		position: relative;
		overflow: hidden;
		transition: box-shadow 0.25s, transform 0.2s, border-color 0.25s;
		cursor: pointer;

		&:hover {
			box-shadow: 0 8px 28px rgba(0, 0, 0, 0.1);
			transform: translateY(-4px);
		}
	}

	.vpc-selected {
		border-color: @pro;
		border-width: 2px;
		box-shadow: 0 4px 20px rgba(37, 99, 235, 0.18);
	}

	.vpc-icon {
		font-size: 30px;
		margin-bottom: 10px;
		.vpc-basic & {
			color: @basic;
		}
		.vpc-pro & {
			color: @pro;
		}
		.vpc-max & {
			color: @max;
		}
	}

	.vpc-name {
		font-size: 18px;
		font-weight: 700;
		color: #1a1f2e;
		margin-bottom: 4px;
	}

	.vpc-price {
		margin-bottom: 12px;
	}

	.vpc-price-now {
		display: flex;
		align-items: baseline;
		justify-content: center;
		gap: 2px;
	}

	.vpc-unit {
		font-size: 16px;
		font-weight: 600;
		color: #da251c;
	}

	.vpc-num {
		font-size: 36px;
		font-weight: 700;
		color: #da251c;
		line-height: 1;
	}

	.vpc-price-original {
		font-size: 12px;
		color: #aaa;
		text-decoration: line-through;
		margin-top: 4px;
	}

	.vpc-discount-tag {
		position: absolute;
		top: -1px;
		left: -1px;
		border-top-left-radius: 10px;
		border-bottom-right-radius: 6px;
		height: 22px;
		line-height: 22px;
		padding: 0 10px;
		font-size: 12px;
	}

	/* ===== 立即开通按鈕 ===== */
	.vpc-buy-btn {
		width: 100%;
		height: 38px;
		border-radius: 20px;
		font-size: 14px;
		font-weight: 600;
		letter-spacing: 1px;
		margin-top: 4px;
		border: 1px solid #d0d5dd;

		&.el-button--primary {
			background: @pro;
			border-color: @pro;
			color: #fff;
		}

		&.el-button--default {
			background: #fff;
			color: #4a4f5e;
			&:hover {
				border-color: @pro;
				color: @pro;
			}
		}
	}

	/* ===== 选中三角形 ===== */
	.selected-triangle {
		position: absolute;
		bottom: 0;
		right: 0;
		width: 0;
		height: 0;
		border-left: 28px solid transparent;
		border-bottom: 28px solid @pro;
		animation: slideIn 0.3s ease-out;

		i {
			position: absolute;
			bottom: -26px;
			right: 2px;
			color: #fff;
			font-size: 11px;
			font-weight: bold;
			animation: fadeIn 0.3s ease-out 0.1s both;
		}
	}

	@keyframes slideIn {
		from {
			transform: translateX(20px) translateY(20px);
			opacity: 0;
		}
		to {
			transform: translateX(0) translateY(0);
			opacity: 1;
		}
	}

	@keyframes fadeIn {
		from {
			opacity: 0;
			transform: scale(0.8);
		}
		to {
			opacity: 1;
			transform: scale(1);
		}
	}

	/* ===== 企业版特色列表 ===== */
	.vpc-features {
		list-style: none;
		padding: 0;
		margin: 0;
		width: 100%;
		text-align: left;

		li {
			font-size: 13px;
			color: #4a4f5e;
			padding: 6px 0 6px 16px;
			position: relative;
			line-height: 1.5;

			&::before {
				content: '';
				position: absolute;
				left: 2px;
				top: 12px;
				width: 5px;
				height: 5px;
				border-radius: 50%;
			}

			.vpc-pro &::before {
				background: @pro;
			}
			.vpc-max &::before {
				background: @max;
			}
			.vpc-basic &::before {
				background: @basic;
			}
		}
	}

	.vp-enterprise-row {
		.vpc {
			cursor: default;
		}
		.vpc-pro {
			box-shadow: 0 4px 20px rgba(37, 99, 235, 0.15);
		}
	}

	/* ===== 购买区域 ===== */
	.vp-buy-wrap {
		margin-bottom: 16px;
	}

	.vp-buy-card {
		background: rgba(255, 255, 255, 0.8);
		border: 1px solid rgba(37, 99, 235, 0.12);
		border-radius: 12px;
		padding: 20px 24px;
		display: flex;
		align-items: flex-start;
		justify-content: space-between;
		gap: 20px;
		backdrop-filter: blur(4px);
	}

	.vp-buy-info {
		flex: 1;
	}

	.vp-buy-text {
		font-size: 14px;
		color: #4a4f5e;
		margin: 0 0 12px;
		b {
			font-weight: 600;
			color: #1a1f2e;
		}
	}

	.vp-buy-price {
		color: #da251c !important;
		font-size: 18px;
	}

	.vp-pay-methods {
		display: flex;
		align-items: center;
		gap: 12px;
		padding: 0;
		margin: 0 0 10px;
		list-style: none;

		li {
			display: flex;
			align-items: center;
			gap: 7px;
			padding: 9px 18px;
			border: 1px solid #d0d5dd;
			background: #fff;
			border-radius: 8px;
			cursor: pointer;
			transition: all 0.2s;
			font-size: 13px;
			color: #4a4f5e;
			&:hover {
				border-color: @pro;
				color: @pro;
			}
			img {
				width: 20px;
				height: 20px;
			}
		}
	}

	.vp-buy-desc {
		font-size: 12px;
		color: #94a3b8;
		margin: 0;
		line-height: 1.6;
	}

	.vp-invite-code {
		display: flex;
		align-items: center;
		gap: 8px;
		flex-shrink: 0;
		cursor: pointer;

		.icon-yaoqingma {
			font-size: 26px;
			color: @pro;
		}

		span {
			font-size: 14px;
			color: @pro;
			font-weight: 500;
			white-space: nowrap;
			&:hover {
				color: @pro-dark;
			}
		}
	}

	/* ===== 促销卡片 ===== */
	.vp-contact-us {
		margin-bottom: 0;
	}

	.vp-contact-card {
		display: flex;
		align-items: center;
		gap: 16px;
		padding: 20px 28px;
		border-radius: 12px;
		background: rgba(255, 255, 255, 0.7);
		border: 1px solid rgba(37, 99, 235, 0.12);
		backdrop-filter: blur(4px);
		transition: box-shadow 0.2s;
		&:hover {
			box-shadow: 0 4px 20px rgba(37, 99, 235, 0.12);
		}
	}

	.vp-contact-icon {
		flex-shrink: 0;
		width: 48px;
		height: 48px;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 50%;
		background: linear-gradient(135deg, @pro, @pro-light);
		color: #fff;
		.icon-vip1 {
			font-size: 26px;
		}
	}

	.vp-contact-body {
		flex: 1;
		display: flex;
		flex-direction: column;
		gap: 3px;
	}

	.vp-contact-label {
		font-size: 15px;
		color: #1a1f2e;
		font-weight: 500;
		b {
			color: #da251c;
		}
	}

	.vp-contact-sub {
		font-size: 12px;
		color: #64748b;
	}

	.vp-register-btn {
		flex-shrink: 0;
		height: 38px;
		padding: 0 24px;
		font-size: 14px;
		font-weight: 600;
	}

	/* ===== 联系方式横幅 ===== */
	.vp-contact-bar {
		display: flex;
		align-items: center;
		padding: 20px 24px;
		background: #fff;
		border-radius: 12px;
		border: 1px solid #edf0f7;
		box-shadow: 0 1px 8px rgba(0, 0, 0, 0.05);
	}

	.vp-contact-bar-left {
		display: flex;
		align-items: center;
		gap: 12px;
	}

	.vp-contact-icon-wrap {
		width: 42px;
		height: 42px;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 50%;
		background: linear-gradient(135deg, @pro, @pro-light);
		color: #fff;
		flex-shrink: 0;
	}

	.vp-contact-bar-label {
		font-size: 15px;
		color: #1a1f2e;
		font-weight: 500;
	}

	.vp-contact-bar-phone {
		font-size: 24px;
		font-weight: 700;
		color: @pro;
		text-decoration: none;
		&:hover {
			color: @pro-dark;
		}
	}

	/* ===== 响应式 ===== */
	@media (max-width: 900px) {
		.vp-price-row {
			flex-direction: column;
		}
		.vp-buy-card {
			flex-direction: column;
		}
		.vp-contact-bar {
			flex-direction: column;
			text-align: center;
			gap: 10px;
		}
		.vp-compare-wrap {
			overflow-x: auto;
		}
		.vp-compare-table {
			min-width: 900px;
		}
	}
</style>
